import { format } from "date-fns";

const DATE_FORMAT = "yyyy年MM月dd日HH時mm分"; 

export const DateFormater = (date: string) => {
  return format(new Date(date), DATE_FORMAT);
};
